import './index.scss'
import { Card, Form, Input, Button, message, Modal, Select } from 'antd'
import logo from '@/assets/logo.png'
import { useDispatch } from 'react-redux';
import { fetchLogin } from '@/store/modules/user';
import { getUserIdByToken, registerAPI } from '@/apis/user';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const { Option } = Select;

const Login = () => {
    const { t } = useTranslation();

    const power = useSelector(state => state.user.userInfo.power)

    const [messageApi, contextHolder] = message.useMessage();
    const info = (msg) => {
        messageApi.info(msg);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    const dispatch = useDispatch()
    const navigate = useNavigate()

    //登录表单提交
    const onLoginFinish = async (values) => {

        //触发异步action
        await dispatch(fetchLogin(values))
        //跳转
        const token = localStorage.getItem('token_key');
        if (token) {
            info("登录成功/Login Successfully")
            navigate('/ProjectUpload')
        }
    };

    //登录表单提交失败
    const onLoginFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    //注册表单提交
    const onRegisterFinish = async (values) => {

        const {
            username,
            password,
            userRole,
            companyId
        } = values

        const data = {
            username,
            password,
            userRole,
            token: '',
            ip: address,
            companyId
        }

        register(data)
        setIsModalOpen(false);
    };

    //注册表单提交失败
    const onRegisterFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const [address, setAddress] = useState('');

    useEffect(() => {
        //获取当前系统IP所属地
        fetch('http://ip-api.com/json')
            .then(response => response.json())
            .then(data => {

                setAddress(`${data.city}-${data.region}-${data.country}`)
            })
            .catch(error => console.error(error));
    }, []);

    //通过接口提交注册表单
    async function register(formData) {

        try {
            const res = await registerAPI(formData)
            info(res.msg)
        } catch (error) {
            console.error("Registration error:", error);
            message.error(
                <>
                    {t('RegistrationFailed')}
                    <br />
                    {t('PleaseTryAgainLater')}
                </>
            );
        }
    }

    return (
        <div className="login">
            {contextHolder}
            <Card className="login-container" style={{ display: 'flex', justifyContent: 'center' }}>
                <img className="login-logo" src={logo} alt='' />
                {/* 登录表单 */}
                <Form validateTrigger="onBlur" onFinish={onLoginFinish} onFinishFailed={onLoginFinishFailed}>
                    <Form.Item
                        label="账号/username："
                        name="username"
                        rules={[{
                            required: true,
                            message: '请输入账号/Please input username'
                        }]}>
                        <Input size="large" />
                    </Form.Item>
                    <Form.Item
                        label="密码/password："
                        name="password"
                        rules={[{
                            required: true,
                            message: '请输入密码/Please input password'
                        }]}>
                        <Input.Password size="large" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" size="large" block>登录</Button>
                    </Form.Item>
                </Form>
                {/* <Button onClick={showModal} type="primary" htmlType="submit" size="large" block>注册</Button> */}
            </Card>

            <Modal title="注册/Regiser" open={isModalOpen} onCancel={handleCancel} footer={null} destroyOnClose={true}>
                <Form layout='vertical' validateTrigger="onBlur" onFinish={onRegisterFinish} onFinishFailed={onRegisterFinishFailed}>

                    <Form.Item
                        label="账号/Username:"
                        name="username"
                        rules={[{
                            required: true,
                            message: 'Please input username'
                        }]}>
                        <Input size="large" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="密码/Password:"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your password!',
                            },
                            {
                                min: 4,
                                required: true,
                                message: 'Password length needs to be longer than 3!',
                            }
                        ]}
                        hasFeedback
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="确认密码/Confirm Password:"
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: 'Please confirm your password!',
                            },
                            {
                                min: 4,
                                required: true,
                                message: 'Password length needs to be longer than 3!',
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('The new password that you entered do not match!'));
                                },
                            }),
                        ]}
                    >
                        <Input.Password />
                    </Form.Item>

                    <Form.Item
                        name="userRole"
                        label="岗位/Role:"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your role!',
                            },
                        ]}
                    >
                        <Select placeholder="Select your role">
                            <Option value="execute">Execute</Option>
                            <Option value="manager">Manager</Option>
                            <Option value="design">Design</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="companyId"
                        label="公司/Company:"
                        rules={[
                            {
                                required: true,
                                message: 'Please input your company!',
                            },
                        ]}
                    >
                        <Select placeholder="Select your company">
                            <Option value="1">Crostars-Guangzhou</Option>
                            <Option value="2">Crostars-Huangzhou</Option>
                            <Option value="3">Crostars-ShangHai</Option>
                            <Option value="4">Crostars-ChangSha</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button style={{}} type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>

                </Form>
            </Modal>

        </div>
    )
}

export default Login